import urls from "../../../global/constants/UrlConstants";
import {
  AstroLinesRequestOptions,
  AstroLinesResponse,
} from "../../../models/interfaces";
import { getCallParams, makeCall } from "../../../utils/service";

/**
 * Fetches a profile's astrocartography lines as a GeoJSON FeatureCollection.
 * All layer flags default ON server-side; they are sent explicitly so the
 * request stays readable and stable if those defaults ever change.
 */
export const getAstrocartographyLines = async (
  profileId: string,
  options: AstroLinesRequestOptions = {},
): Promise<AstroLinesResponse> => {
  try {
    const {
      includeOuter = true,
      includeAspects = true,
      includeInterpretations = true,
      interpretationLangs = ["en", "pl"],
    } = options;

    const query = new URLSearchParams({
      include_outer: String(includeOuter),
      include_aspects: String(includeAspects),
      include_interpretations: String(includeInterpretations),
      interpretation_langs: interpretationLangs.join(","),
    });

    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.astrocartographyLines}/${profileId}?${query.toString()}`,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};
